/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPhone12(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={12}
      fill='none'
      viewBox='0 0 12 12'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M7.179 1.606l.051.007c1.133.152 2.152.711 2.835 1.553.683.842.973 1.897.806 2.935l-.009.053M3.278 8.284c1.656 1.849 3.38 2.573 4.41 2.856a1.84 1.84 0 001.567-.295l1.541-1.159a.378.378 0 00.06-.564L9.373 7.465a.466.466 0 00-.616-.056l-1 .754a.355.355 0 01-.28.062s0 0 0 0a4.183 4.183 0 01-2.329-1.294l-.028-.032M3.278 8.284C1.62 6.435 1.18 4.744 1.079 3.764c-.048-.516.184-1.021.621-1.35l1.541-1.16a.465.465 0 01.616.056L5.34 2.967a.379.379 0 01-.06.564l-1.001.753a.295.295 0 00-.122.238s0 0 0 0c.01.856.34 1.684.932 2.346l.029.031'
      />
    </svg>
  );
}

export default SvgPhone12;
